import { BookOpen, MessageSquare } from 'lucide-react';
import type { ComponentType } from 'react';

export type TimelineTone = 'chat' | 'journal';

type TimelineToneStyles = {
  icon: ComponentType<{ className?: string }>;
  iconWrapperClassName: string;
  statusDotClassName: string;
  rowClassName: string;
  rowHoverClassName: string;
};

export const TIMELINE_TONE_STYLES: Record<TimelineTone, TimelineToneStyles> = {
  chat: {
    icon: MessageSquare,
    iconWrapperClassName: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
    statusDotClassName: 'bg-blue-500',
    rowClassName: 'bg-blue-50 border-blue-100/70 dark:bg-blue-950/30 dark:border-blue-900/50',
    rowHoverClassName:
      'hover:bg-blue-100 hover:border-blue-200/70 dark:hover:bg-blue-950/45 dark:hover:border-blue-800/60',
  },
  journal: {
    icon: BookOpen,
    iconWrapperClassName: 'bg-amber-500/10 text-amber-600 dark:text-amber-500',
    statusDotClassName: 'bg-amber-500',
    rowClassName:
      'bg-amber-50 border-amber-100/70 dark:bg-amber-950/30 dark:border-amber-900/50',
    rowHoverClassName:
      'hover:bg-amber-100 hover:border-amber-200/70 dark:hover:bg-amber-950/45 dark:hover:border-amber-800/60',
  },
};

export function getTimelineToneStyles(tone: TimelineTone): TimelineToneStyles {
  return TIMELINE_TONE_STYLES[tone];
}
